import { IScriptDTO } from '@/modules/scripts/dtos/script.dto';
import { IScript } from '@/modules/scripts/entities/script.entity';

export class ScriptMapper {
  static toPresentation(dto: IScriptDTO): IScript {
    return {
      id: dto.id,
      order: dto.ordem,
      text: dto.texto,
      voice: {
        id: dto.voz.id,
        name: dto.voz.nome,
        slug: dto.voz.slug,
        gender: dto.voz.genero,
      },
    };
  }

  static toDTO(script: IScript): IScriptDTO {
    return {
      id: script.id,
      ordem: script.order,
      texto: script.text,
      voz: {
        id: script.voice.id,
        nome: script.voice.name,
        genero: script.voice.gender,
        slug: script.voice.slug,
      },
    };
  }
}
